import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "aset" }
const _hoisted_2 = { class: "sui-card" }
const _hoisted_3 = { class: "sui-card__body" }
const _hoisted_4 = {
  key: 0,
  class: "aset__error"
}
const _hoisted_5 = { class: "aset__field" }
const _hoisted_6 = { class: "aset__field" }
const _hoisted_7 = { class: "aset__field" }
const _hoisted_8 = { class: "aset__field aset__field--wide" }
const _hoisted_9 = { class: "aset__field aset__field--wide" }
const _hoisted_10 = { class: "aset__actions" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  class: "sui-card aset__preview",
  "data-tour": "admin-settings-preview"
}
const _hoisted_13 = { class: "sui-card__body" }
const _hoisted_14 = { class: "aset__remote" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

import { computed, onMounted, reactive, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { useAdminProducts } from '@/composables/useAdminProducts'
import { fetchPaymentInfo, saveAdminPaymentInfo, type MallPaymentInfo } from '@/api/mallOrder'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminSettingsPage',
  setup(__props) {

const { notify } = useAdminProducts()

const form = reactive<MallPaymentInfo>({
  bankName: '',
  account: '',
  holder: '',
  notice: '',
  opsNotice: '',
})

const loading = ref(false)
const saving = ref(false)
const errorMessage = ref('')

const canSave = computed(
  () => Boolean(form.bankName && form.account && form.holder) && !loading.value,
)

onMounted(async () => {
  loading.value = true
  errorMessage.value = ''
  try {
    const payment = await fetchPaymentInfo()
    form.bankName = payment.bankName
    form.account = payment.account
    form.holder = payment.holder
    form.notice = payment.notice
    form.opsNotice = payment.opsNotice || ''
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '입금 정보를 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
})

async function onSave() {
  if (!canSave.value || saving.value) return
  if (!window.confirm('입금 계좌 · 운영 설정을 저장할까요?')) return

  saving.value = true
  errorMessage.value = ''
  try {
    const payment = await saveAdminPaymentInfo({ ...form })
    form.bankName = payment.bankName
    form.account = payment.account
    form.holder = payment.holder
    form.notice = payment.notice
    form.opsNotice = payment.opsNotice || ''
    notify('설정을 저장했습니다.')
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '저장에 실패했습니다.'
  } finally {
    saving.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "sui-card__head" }, [
        _createElementVNode("h2", { class: "sui-card__title" }, "입금 계좌")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "aset__lead" }, " 구매 기관이 결제 안내 화면에서 보는 계좌입니다. 통장이 바뀌면 여기서 바로 고쳐 주세요. ", -1)),
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createVNode(AppIcon, {
                icon: "mdi-alert-outline",
                size: 16
              }),
              _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          class: "aset__form",
          "data-tour": "admin-settings-form",
          onSubmit: _withModifiers(onSave, ["prevent"])
        }, [
          _createElementVNode("label", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "은행명", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.bankName) = $event)),
              type: "text",
              maxlength: "50",
              placeholder: "예: 국민은행"
            }, null, 512), [
              [
                _vModelText,
                form.bankName,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("label", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "계좌번호", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.account) = $event)),
              type: "text",
              maxlength: "50",
              placeholder: "예: 123456-78-901234"
            }, null, 512), [
              [
                _vModelText,
                form.account,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("label", _hoisted_7, [
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "예금주", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.holder) = $event)),
              type: "text",
              maxlength: "50",
              placeholder: "예: 주식회사 함우리"
            }, null, 512), [
              [
                _vModelText,
                form.holder,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("label", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "안내 문구", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.notice) = $event)),
              rows: "3",
              maxlength: "255",
              placeholder: "필요하면 입금·확인 관련 안내를 적어 주세요. 비우면 안내가 숨겨집니다."
            }, null, 512), [
              [
                _vModelText,
                form.notice,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("label", _hoisted_9, [
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "몰 홈 운영 공지", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.opsNotice) = $event)),
              rows: "2",
              maxlength: "255",
              placeholder: "예: 설 연휴 배송 일정 안내 — 비우면 배너가 숨겨집니다."
            }, null, 512), [
              [
                _vModelText,
                form.opsNotice,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "submit",
              class: "sui-btn sui-btn--primary",
              disabled: saving.value || !canSave.value
            }, _toDisplayString(saving.value ? '저장 중…' : '저장'), 9, _hoisted_11)
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "sui-card__head" }, [
        _createElementVNode("h2", { class: "sui-card__title" }, "구매 기관에게 보이는 모습")
      ], -1)),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("dl", _hoisted_14, [
          _createElementVNode("div", null, [
            _cache[12] || (_cache[12] = _createElementVNode("dt", null, "입금 은행", -1)),
            _createElementVNode("dd", null, _toDisplayString(form.bankName || '—'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[13] || (_cache[13] = _createElementVNode("dt", null, "계좌번호", -1)),
            _createElementVNode("dd", null, _toDisplayString(form.account || '—'), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[14] || (_cache[14] = _createElementVNode("dt", null, "예금주", -1)),
            _createElementVNode("dd", null, _toDisplayString(form.holder || '—'), 1)
          ]),
          (form.notice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _cache[15] || (_cache[15] = _createElementVNode("dt", null, "안내", -1)),
                _createElementVNode("dd", null, _toDisplayString(form.notice), 1)
              ]))
            : _createCommentVNode("", true),
          (form.opsNotice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _cache[16] || (_cache[16] = _createElementVNode("dt", null, "운영 공지", -1)),
                _createElementVNode("dd", null, _toDisplayString(form.opsNotice), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})